module.exports = __webpack_public_path__ + "img/part1-watermark.2866c8bc.png";